import React, { Component } from "react";
import {
  Button,
  FormGroup,
  TextField,
} from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import logo from "assets/img/front-logo.png";
import "assets/css/login.css";
import { twofaService } from "_services/twofa.service";

class AddPhoneNumber extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phoneCode: "+1",
      phoneNumber: "",
      loading: false,
      error: "",
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value, error: "" });
  };

  validateForm() {
    const { phoneNumber } = this.state;
    return phoneNumber.length >= 7 && phoneNumber.length <= 15;
  }

  async handleSubmit(event) {
    event.preventDefault();
    this.setState({ loading: true, error: "" });

    try {
      const data = await twofaService.updatePhone(
        this.props.preAuthToken,
        this.state.phoneCode,
        this.state.phoneNumber
      );

      if (data.status === "OTP_SENT") {
        this.props.onOtpSent(data.maskedPhone);
      } else if (data.status === "SESSION_EXPIRED") {
        this.props.onSessionExpired();
      } else {
        this.setState({ error: data.message || "Failed to send OTP" });
      }
    } catch (err) {
      this.setState({
        error: err.message || "Unable to send OTP. Please try again.",
      });
    }

    this.setState({ loading: false });
  }

  render() {
    return (
      <div className="login-outer-cover">
        <div className="login-cover gray-bg-color">
          <div className="logo-content loginLogoMain">
            <div className="loginLogoInner">
              <img src={logo} alt="logo" />
            </div>
          </div>
          <div className="login-inner-cover">
            <div className="login-content">
              <div className="Login">
                <h3 style={{ marginBottom: "10px", textAlign: "center" }}>
                  Set Up Two-Factor Authentication
                </h3>
                <p style={{ marginBottom: "8px", textAlign: "center", color: "#666", fontSize: "14px" }}>
                  As part of our security enhancements, two-factor authentication is now required for all accounts. Please complete the setup to continue.
                </p>
                <p style={{ marginBottom: "20px", textAlign: "center", color: "#666", fontSize: "13px" }}>
                  Enter a phone number to receive verification codes when you log in.
                </p>
                <form onSubmit={this.handleSubmit} noValidate>
                  <FormGroup style={{ flexDirection: "row", alignItems: "flex-end", gap: "10px" }}>
                    <TextField
                      select
                      label="Code"
                      name="phoneCode"
                      value={this.state.phoneCode}
                      onChange={this.handleChange}
                      style={{ width: "90px" }}
                      SelectProps={{ native: true }}
                    >
                      <option value="+1">+1 (US)</option>
                      <option value="+63">+63 (PH)</option>
                      <option value="+91">+91 (IN)</option>
                    </TextField>
                    <TextField
                      label="Phone Number *"
                      type="tel"
                      name="phoneNumber"
                      value={this.state.phoneNumber}
                      onChange={this.handleChange}
                      inputProps={{ maxLength: 15 }}
                      style={{ flex: 1 }}
                    />
                  </FormGroup>

                  {this.state.error && (
                    <p style={{ color: "red", fontSize: "13px", marginTop: "10px" }}>
                      {this.state.error}
                    </p>
                  )}

                  <div className="action-btns" style={{ marginTop: "20px" }}>
                    <Button
                      color="primary"
                      className={this.state.loading ? "buttonSuccess btn1" : "btn1"}
                      disabled={this.state.loading || !this.validateForm()}
                      type="submit"
                    >
                      Send Verification Code
                      {this.state.loading && (
                        <CircularProgress size={24} className="buttonProgress" />
                      )}
                    </Button>
                  </div>

                  <div style={{ textAlign: "center", marginTop: "10px" }}>
                    <a
                      href="#"
                      onClick={(e) => { e.preventDefault(); this.props.onBackToLogin(); }}
                      style={{ color: "#1976d2", fontSize: "14px" }}
                    >
                      Back to Login
                    </a>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddPhoneNumber;
